<template>
  <div class="statistics" :class="classes">
    <ManagementStatistic
        v-for="statistic in statistics"
        :key="statistic.key"
        :value="statistic.value"
        :heading="statistic.heading"
        :subHeading="statistic.subHeading"
        :subValue="statistic.subValue"
        :showSkeleton="statistic.loading"
        :testLabel="statistic.key"
        :class="statistic.classes"
        :tool-tip="statistic.toolTip"
    />
  </div>
</template>

<script>
import ManagementStatistic from '@/components/ManagementStatistic.vue';

export default {
  name: 'Statistics',
  components: { ManagementStatistic },
  props: {
    statistics: Array,
    noBorders: Boolean,
    dense: Boolean,
  },
  computed: {
    classes() {
      return {
        borders: !this.noBorders,
        padding: this.dense ? 0 : '1rem',
      };
    },
  }
};
</script>

<style scoped>
.statistics {
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.statistics.borders {
  border-top: 1px solid var(--v-border-base);
  border-bottom: 1px solid var(--v-border-base);
}
</style>
